import { useQuery } from '@tanstack/react-query';
import useJwt from '../../utils/useJwt';

export type AddressType = {
  firstname: string;
  lastname: string;
  address1: string;
  address2?: string;
  zipcode: string;
  city: string;
  countryCode?: string;
  mobilePhone: string;
  email?: string;
};

export default function useAccountAddress() {
  const jwt = useJwt();
  return useQuery<AddressType, Error>({
    queryKey: ['account/address', { jwt }],
    enabled: !!jwt,
  });
}
